import { __require as l } from "./contact-channels236.js";
import { __require as c } from "./contact-channels237.js";
var e, _;
function p() {
  if (_) return e;
  _ = 1;
  var f = e && e.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  }, n = f(l()), o = c();
  function t(r, s) {
    var i = {};
    return !r || typeof r != "string" || (0, n.default)(r, function(u, a) {
      u && a && (i[(0, o.camelCase)(u, s)] = a);
    }), i;
  }
  return t.default = t, e = t, e;
}
export {
  p as __require
};
//# sourceMappingURL=contact-channels228.js.map
